import Strings from "@my-dld/assets/strings";
import React from "react";
import { LocaleUtil } from "@eres/core";
import { Property } from "../../api/Property";
import { RVPropertyType } from "../../api/entities";
import EjariWebConfig from "@eres/ejari-web/EjariWebConfig";
import { getOPMunNo } from "./RVPropertyTable";

export function RVPropertyHeader( props: { property?: Property } ) {
	const { property } = props;
	if ( property == null ) return <React.Fragment/>;
	let { val, lbl, icon, building_name } = extractPropInfo( property );
	return <div className="property-info-summary">
		<div>
			<div className="property-icon">
				<img src={ EjariWebConfig.rootUrl + "assets/property-icons/" + icon + ".svg" } alt="app logo"/>
			</div>
		</div>
		<div className="seperator-v"/>
		<div>
			<span>{ val }</span>
			<span>{ lbl }</span>
		</div>
		<div className="seperator-v"/>
		{
			building_name &&
			<div>
				<span>{ building_name }</span>
				<span>{ Strings.building_name }</span>
			</div>
		}
		<div className="seperator-v"/>
		<div>
			<span>{ LocaleUtil.getLocalValue( { en: property.AreaEn, ar: property.AreaAr } ) }</span>
			<span>{ Strings.area }</span>
		</div>
	</div>;
}

export function extractPropInfo( property: Property ) {
	let icon = "unit";
	let val = "";
	let lbl = "";
	let building_name = "";
	switch ( property.PropertyTypeId ) {
		case RVPropertyType.LAND:
			val = getOPMunNo( property );
			lbl = Strings.land_num_label;
			icon = "land";
			break;
		case RVPropertyType.UNIT:
			val = property.UnitNo;
			lbl = Strings.Unit_Number_Label;
			building_name = LocaleUtil.getLocalValue( { en: property.BuildingNameEn, ar: property.BuildingNameAr } );
			icon = "unit";
			break;
		case RVPropertyType.VILLA:
			val = LocaleUtil.getLocalValue( { en: property.BuildingNameEn, ar: property.BuildingNameAr } );
			lbl = Strings.villa_name;
			icon = "villa";
			break;
		case RVPropertyType.BUILDING:
			val = LocaleUtil.getLocalValue( { en: property.BuildingNameEn, ar: property.BuildingNameAr } );
			lbl = Strings.building_name;
			icon = "building";
			break;
	}
	return { val, lbl, icon, building_name };
}
